import { render, staticRenderFns } from "./ProductEditWriteOff.vue?vue&type=template&id=ca580ff2"
import script from "./ProductEditWriteOff.vue?vue&type=script&lang=ts"
export * from "./ProductEditWriteOff.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports